import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';


const TermsOfUse = () => {

    return (
        <>
            <SEO title="Terms Of Use" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title="Terms Of Use"
                page="Terms Of Use"
                />
                <div className="section-padding privacy-policy-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="privacy-policy-content">
                                    <h3>Effective Date: [31st December 2024]</h3>
                                <p>Welcome to NewwayIT! These Terms of Use ("Terms") govern your access to and use of our website and services. By using our website, you agree to these Terms. If you do not agree, please do not use our website.</p>
                                <h4>1. Acceptance of Terms</h4>
                                <p>By accessing or using the website, you confirm that you are at least 18 years old and agree to comply with these Terms. If you are accessing on behalf of an organization, you represent that you have the authority to bind that organization to these Terms.</p>
                                <h4>2. Use of Website</h4>
                                <p>You agree to use the website only for lawful purposes and in a manner that does not infringe the rights of others or restrict their use and enjoyment of the website. Prohibited activities include, but are not limited to: <br/>
                                <br/>
--Engaging in any fraudulent activity.
<br/>
<br/>
--Introducing malicious software or attempting to disrupt the website’s operation.
<br/>
<br/>
--Copying, distributing, or disclosing any part of the website without authorization.</p>
                                <h4>3. Intellectual Property</h4>
                                <p>All content on this website, including text, graphics, logos, images, and software, is the property of NewwayIT or its licensors and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works from any part of this website without our explicit written permission.</p>
                                <h4>4. Privacy</h4>
                                <p>Your use of our website is also governed by our Privacy Policy, which explains how we collect, use, and safeguard your information. By using our website, you consent to the practices described in the Privacy Policy.</p>
                                <h4>5. Limitation of Liability</h4>
                                <p>To the fullest extent permitted by law, NewwayIT shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of the website, including but not limited to:<br/>
                                <br/>
--Loss of profits.
<br/>
<br/>
--Data loss.
<br/>
<br/>
--Business interruptions.</p>
                                <h4>6. Disclaimer of Warranties</h4>
                                <p>The website is provided "as is" and "as available" without any warranties of any kind, either express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement. We do not guarantee that the website will be secure, error-free, or uninterrupted.</p>
                                <h4>7. Third-Party Links</h4>
                                <p>Our website may contain links to third-party websites. These links are provided for your convenience only. We do not endorse or control these websites and are not responsible for their content or practices.</p>
                                <h4>8. Modifications to Terms</h4>
                                <p>NewwayIT reserves the right to modify these Terms at any time. Any changes will be posted on this page with an updated effective date. Your continued use of the website after changes constitutes your acceptance of the revised Terms.</p>
                                <h4>9. Governing Law</h4>
                                <p>These Terms are governed by and construed in accordance with the laws of [Insert Jurisdiction], without regard to its conflict of laws principles. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts located in [Insert Jurisdiction].</p>
                                <h4>10. Contact Us</h4>
                                <p> If you have any questions about these Terms, please contact us:<br/> <br/>
                                    NewwayIT<br/>
Email: [info@newwayit.com]
<br/>
Phone: [90563-44481, 90563-44485]
<br/>
Address: [Main Market, Street No. 8, Old Bishan Nagar,
    Patiala, Punjab 147001]</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CtaLayoutOne />
            <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default TermsOfUse;